export default {
    auth: {
        login: {
            title: '선생님 로그인',
            buttons: {
                enter: '로그인',
                chathess: '체더스 로그인',
                register: '회원가입',
            },
        },
    },
    register: {
        title: '회원가입',
        description: '회원가입에 필요한 정보를 입력해 주세요',
        chathessId: '체더스 아이디',
        accountInfo: '계정 정보',
        accessId: '아이디',
        password: '비밀번호',
        passwordConfirm: '비밀번호 확인',
        buttons: {
            cancel: '취소',
            register: '회원가입',
        },
    },
    home: {
        title: '활동을 눌러 학습을 시작해주세요.',
    },
    self: {
        title: '자습 모드 현황',
        taskTitle: '과제 진행 현황',
        clear: '전원 완료!',
        tabs: {
            all: '전체 보기',
            completed: '완료한 학생',
            inProgress: '진행중인 학생',
        },
        noStudent: ({ values }: { values: { tab: string } }) => {
            const { tab } = values;

            if (tab === 'completed') {
                return '완료한 학생이 없어요.';
            } else if (tab === 'in_progress') {
                return '진행중인 학생이 없어요.';
            } else {
                return '학생이 없어요.';
            }
        },
        table: {
            name: '이름',
            progress: '진행률',
            star: '칭찬별',
            module: '모듈',
            time: '소요 시간',
        },
    },
};
